import request from '../utils/request';

export function getOrderList(params) {
    return request({
        url: '/order/list',
        method: 'get',
        params
    });
}

export function createOrder(data) {
    return request({
        url: '/order/create',
        method: 'post',
        data
    });
}

export function updateOrder(data) {
    return request({
        url: '/order/update',
        method: 'post',
        data
    });
}

export function exportOrder(data) {
    return request({
        url: '/order/export',
        method: 'post',
        data
    });
}
